import { React } from "react";
import { Container } from "react-bootstrap";
import CardSettings from "./CardSettings";
import "../css/Home.css";
import "../css/ComingSoon.css";
import "../css/Settings.css";
import { Helmet } from "react-helmet";
import { useAuth } from './AuthContext';
import ModalCongrats from "./ModalCongrats";

function Settings() {
  const { isAuthenticated } = useAuth();
  console.log("Auth Status:", isAuthenticated);
  const video_row_2 =
    "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/video_runsteps.mp4";
  const { showCongrats, setShowCongrats } = useAuth();
  const handleCloseCongrats = () => {
    setShowCongrats(false);
  };

  return (
    <div className="page">
      <Helmet>
        <title>thenics4all</title>
        <meta
          name="description"
          content="Step-by-step Handstand pushup progressions, training and tutorials."
        />
        <meta
          name="keywords"
          content="handstand, handstand pushup, hspu, calisthenics, progression, tutorial"
        />
      </Helmet>
      <Container fluid>
        <div className="home-row row-program">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="home-row-video-background"
          >
            <source src={video_row_2} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="card-settings-container">
            <CardSettings />
          </div>
        </div>
        <ModalCongrats show={showCongrats} onHide={handleCloseCongrats} />
      </Container>
    </div>
  );
}
export default Settings;
